import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { services } from "../data/site";
import { Seo, breadcrumbLd } from "../components/Seo";
import { PageHero, CTABand } from "../components/ui-blocks";

const Services = () => {
  return (
    <div>
      <Seo
        title="Services — Stone Fabrication & Installation"
        description="Custom stonework for residential and commercial spaces: kitchen countertops, islands, bathroom vanities, commercial surfaces, fireplaces and custom fabrication."
        path="/services"
        jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])}
      />
      <PageHero
        eyebrow="Services"
        title="Custom Stonework for Residential & Commercial Spaces"
        subtitle="From the first measurement to final installation, we fabricate and install stone surfaces built to perform and designed to impress."
        image={services[0].image}
        testid="services-hero"
      />

      <section className="section bg-white">
        <div className="container-custom space-y-20">
          {services.map((s, i) => (
            <div key={s.slug} className="grid lg:grid-cols-2 gap-12 items-center" data-testid={`service-${s.slug}`}>
              <div className={`img-zoom rounded-lg overflow-hidden h-80 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <img src={s.image} alt={s.title} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                <h2 className="text-3xl sm:text-4xl mb-3">{s.title}</h2>
                <p className="text-neutral-600 mb-6 leading-relaxed">{s.blurb}</p>
                <ul className="grid sm:grid-cols-2 gap-3 mb-8">
                  {s.applications.map((a) => (
                    <li key={a} className="flex items-start gap-2.5 text-sm text-neutral-700">
                      <Check size={16} className="text-[#CD1422] mt-0.5 shrink-0" /> {a}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="btn btn-primary">Request a Quote <ArrowRight size={17} /></Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default Services;
